// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseStudentUrl: "https://3civ127cfd.execute-api.us-east-1.amazonaws.com/develop",
  baseAdminUrl: "https://6014qccxa6.execute-api.us-east-1.amazonaws.com/develop",
  userPoolId: 'us-east-1_rVBf09Zll',
  userPoolClientId: 'ggtepk32aqk5hu7g7duphg7qk',
  studentDefaultPassword: 'nanosurveystudentuser12345#!'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
